export function getAppDefaultPaths() {
  const redirectLoginPath = '/login';
  const manualLoginPath = '/_login';
  const defaultHomePath = '/';
  return {
    home: defaultHomePath,
    login: redirectLoginPath,
    manualLogin: manualLoginPath,
  };
}